import Navbar from "../../../components/navbar";
import BlogItem from '../../../components/blog/item';
import Footer from '../../../components/footer';

import { data } from '../../../components/blog/data';

import { Link } from "react-router-dom";
import { Link as Links } from 'react-scroll';

const BlogGrid = () =>{
    return(
    <>
    <header
    className="container-fluid bg-primary headerExtra"
    id="home">
      <div className="container h-100">
      <Navbar />
        <div className="d-flex flex-column align-items-center justify-content-center h-75 text-white">
          <h1 className="display-4">
            Blog grid 01
          </h1>
          <div>
            <Link
            className="text-white mx-2"
            to="/home01">
              Home
            </Link>
              &#11166;
            <Link
            className="text-white mx-2"
            to="/blog01">
              Blog Grid
            </Link>
          </div>
        </div>
      </div>
    </header>
    <div className="container d-flex flex-column-reverse flex-md-row division2">
      <div className="col-12 col-md-6 col-lg-8 d-flex flex-wrap">
        {
          data.map((e) =>(
            <div className="col-12 col-lg-6 my-3">
              <div className="row px-lg-2">
                <BlogItem
                title={e.title}
                img={e.thumbnail}
                />
              </div>
            </div>
          ))
        }
      </div>
      <div className="col-12 col-md-6 col-lg-4">
        <div className="my-3">
          <input
          type="text"
          placeholder="Search"
          className="form-control form-control-lg"
          />
        </div>
        <aside>
          <div className="card w-100">
            <div className="card-body">
              <h4
              className="card-title font-weight-bold border-bottom pb-2">
                Categories
              </h4>
              <ul className="mt-4 p-0">
                <li
                className="d-flex font-weight-bold my-3"
                  style={{fontSize: '1rem', color: '#707070'}}>
                  <span>&#10148;</span>
                  <Links
                  to="home"
                  smooth
                  className="mx-3 text-dark">
                    Web Disign
                  </Links>
                  <span>(24)</span>
                </li>
                <li
                className="d-flex font-weight-bold my-3"
                style={{fontSize: '1rem', color: '#707070'}}>
                  <span>&#10148;</span>
                  <Links
                  to="home"
                  smooth
                  className="mx-3 text-dark">
                    Marketing
                  </Links>
                  <span>(24)</span>
                </li>
                <li
                className="d-flex font-weight-bold my-3"
                style={{fontSize: '1rem', color: '#707070'}}>
                  <span>&#10148;</span>
                  <Links
                  to="home"
                  smooth
                  className="mx-3 text-dark">
                    FrontEnd
                  </Links>
                  <span>(24)</span>
                </li>
                <li
                className="d-flex font-weight-bold my-3"
                style={{fontSize: '1rem', color: '#707070'}}>
                  <span>&#10148;</span>
                  <Links
                  to="home"
                  smooth
                  className="mx-3 text-dark">
                    IT & e Software
                  </Links>
                  <span>(24)</span>
                </li>
                <li
                className="d-flex font-weight-bold my-3"
                style={{fontSize: '1rem', color: '#707070'}}>
                  <span>&#10148;</span>
                  <Links
                  to="home"
                  smooth
                  className="mx-3 text-dark">
                    Photography
                  </Links>
                  <span>(24)</span>
                </li>
                <li
                className="d-flex font-weight-bold my-3"
                style={{fontSize: '1rem', color: '#707070'}}>
                  <span>&#10148;</span>
                  <Links
                  to="home"
                  smooth
                  className="mx-3 text-dark">
                    Tecnology
                  </Links>
                  <span>(24)</span>
                </li>
                <li
                className="d-flex font-weight-bold my-3"
                style={{fontSize: '1rem', color: '#707070'}}>
                  <span>&#10148;</span>
                  <Links
                  to="home"
                  smooth
                  className="mx-3 text-dark">
                    General
                  </Links>
                  <span>(24)</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="card w-100 mt-4">
            <div className="card-body">
              <h4
              className="card-title font-weight-bold border-bottom pb-2">
                Popular tags
              </h4>
              <div className="d-flex flex-wrap">
                <div className="col-6 px-1 mt-2">
                  <button className="btn btn-light">
                    Web Disign
                  </button>
                </div>
                <div className="col-4 p-1">
                  <button className="btn btn-light">
                    Marketing
                  </button>
                </div>
                <div className="col-4 p-1">
                  <button className="btn btn-light">
                    FrontEnd
                  </button>
                </div>
                <div className="col-8 p-1">
                  <button className="btn btn-light">
                    IT & Software
                  </button>
                </div>
                <div className="col-4 p-1">
                  <button className="btn btn-light">
                    Online
                  </button>
                </div>
                <div className="col-4 p-1">
                  <button className="btn btn-light">
                    Motivation
                  </button>
                </div>
                <div className="col-5 p-1">
                  <button className="btn btn-light">
                    Artist
                  </button>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
    <nav className="d-flex justify-content-center division2">
      <ul className="pagination pagination-md-lg">
        <li className="page-item">
          <Link
          className="page-link"
          aria-label="previous">
            <span aria-hidden="true">
              &laquo;
            </span>
            <span class="sr-only">
              previous
            </span>
          </Link>
        </li>
        <li className="page-item">
          <Link className="page-link">
            1
          </Link>
        </li>
        <li className="page-item">
          <Link className="page-link">
            2
          </Link>
        </li>
        <li className="page-item">
          <Link className="page-link">
            3
          </Link>
        </li>
        <li className="page-item">
          <Link
          className="page-link"
          aria-label="next">
            <span aria-hidden="true">
              &raquo;
            </span>
            <span className="sr-only">
              next
            </span>
          </Link>
        </li>
      </ul>
    </nav>
    <Footer />
    </>
  )
};
export default BlogGrid;